import React from "react";
import { Link, useNavigate } from "react-router-dom";
import support from "./../../../assets/HomeAssets/assets/images/support.png";
import appStore from "./../../../assets/HomeAssets/assets/images/AppStore.svg";
import palyStore from "./../../../assets/HomeAssets/assets/images/GooglePlay.svg";
import lionsLogo from "../../../assets/images/headercreationlogo.png";
import { environment } from "../../../config";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navigate = useNavigate();
  const handleNavifate = () => {
    navigate("/contact");
    // window.open("http://support.jkdigitals.net");
  };
  return (
    <>
      {/* footer-wrap */}
      <footer>
        <div className="footer-wrap footerrpading">
          <div className="theme-container">
            <div className="st-footer-logo ">
              <img src={lionsLogo} alt="f-logo" />
            </div>
            <button
              onClick={handleNavifate}
              className="btn btnsupport desk-none "
            >
              <img src={support} alt="support" />
              Contact Support
            </button>
            <div className="row col-rev mt3 ">
              <div className="col-lg-8">
                <div className="row">
                  <div className="col-sm-6">
                    <ul className="footer-list">
                      <li>
                        <Link to={"/about-us"}>About Us</Link>
                      </li>
                      <li className="ml13">
                        <Link to={"/contact"}>Contact</Link>
                      </li>
                      <li className="ml13">
                        <Link to={"/data-deletion"}>Data Deletion</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-sm-6">
                    <ul className="footer-list">
                      <li>
                        <Link to={"/use-policy-terms"}>
                          Terms and Conditions
                        </Link>
                      </li>
                      <li className="ml13">
                        <Link to={"/privacy-policy"}>Privacy</Link>
                      </li>
                      <li className="ml13">
                        <Link to={"/affiliate-artist"}>Affiliate Artist</Link>
                      </li>
                      {/* Affiliate Artist */}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-4   text-end dis-none">
                <button onClick={handleNavifate} className="btn btnsupport ">
                  <img src={support} alt="support" />
                  Contact Support
                </button>
                <div className="flex row mt-2  mb-4">
                  <h1 className="font-24 text-center mb-2  theme-container-h1">
                    Download Our App
                  </h1>
                  <div className="col-6 ">
                    <Link  target="_blank"
                    rel="noopener noreferrer"
                    to="https://www.lionsdengames.net/download-android">
                      <img
                        className="google-play-btn"
                        src={palyStore}
                        alt="support"
                      />
                    </Link>
                  </div>
                  <div className="col-6   ">
                    <Link  target="_blank"
                    rel="noopener noreferrer"
                    to="https://www.lionsdengames.net/download-ios">
                      <img
                        className="google-play-btn"
                        src={appStore}
                        alt="support"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex row mt-2 desk-none mb-10">
              <h1 className="font-24 text-center mb-2  theme-container-h1">
                Download Our App
              </h1>
              <div className="col-12 mb-2 ">
                <Link  target="_blank"
                    rel="noopener noreferrer"
                    to="https://www.lionsdengames.net/download-android">
                  <img
                    className="google-play-btn"
                    src={palyStore}
                    alt="support"
                  />
                </Link>
              </div>
              <div className="col-12 mb-2   ">
                <Link  target="_blank"
                    rel="noopener noreferrer"
                    to="https://www.lionsdengames.net/download-ios">
                  <img
                    className="google-play-btn"
                    src={appStore}
                    alt="support"
                  />
                </Link>
              </div>
            </div>
            <h1 className="font-16 theme-container-h1">
              Lionsdengames&reg; Entertainment
            </h1>
            <p className="font-16-medium theme-container-p">
              Jkdigitals is an artist collective focused on giving back to
              their <br />
              online community through sweepstakes and giveaways.
            </p>

            <h1 className="font-16 theme-container-h1">Address Information</h1>
            <div className="footer-address">
              <p className="font-16-medium theme-container-p mt-nne ">
                J&K Studios
              </p>
              <p className="font-16-medium theme-container-p mt-nne ">
                1925 Grand Ave. Suite 127 Billings, Montana 59102
              </p>

              <p className="font-16-medium theme-container-p mt-nne">
                254-290-9210
              </p>
            </div>

            <div className=" ">
              <p className="  text-white">
                © 2024 JKDIGITALS. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
      {/* <div className="footer_second  bg_lit">
        <p className="text-white">
          © {currentYear} JKDIGITALS. All rights reserved.
        </p>
      </div> */}
    </>
  );
};

export default Footer;
